import { defineComponent } from "vue"


export const ArrowDown = defineComponent({
  name: 'icon-arrow-down',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M831.872 340.864L512 652.672 192.128 340.864a30.592 30.592 0 00-42.752 0 29.12 29.12 0 000 41.6L489.664 714.24a32 32 0 0044.672 0l340.288-331.712a29.12 29.12 0 000-41.728 30.592 30.592 0 00-42.752 0z"></path></svg>
    )
  }
})


export const ArrowDownBold = defineComponent({
  name: 'icon-arrow-down-bold',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M104.704 338.752a64 64 0 0190.496 0l316.8 316.8 316.8-316.8a64 64 0 0190.496 90.496L557.248 791.296a64 64 0 01-90.496 0L104.704 429.248a64 64 0 010-90.496z"></path></svg>
    )
  }
})


export const ArrowLeft = defineComponent({
  name: 'icon-arrow-left',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M609.408 149.376L277.76 489.6a32 32 0 000 44.672l331.648 340.352a29.12 29.12 0 0041.728 0 30.592 30.592 0 000-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 000-42.688 29.12 29.12 0 00-41.728 0z"></path></svg>
    )
  }
})

export const ArrowLeftBold = defineComponent({
  name: 'icon-arrow-left-bold',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M685.248 104.704a64 64 0 010 90.496L368.448 512l316.8 316.8a64 64 0 01-90.496 90.496L232.704 557.248a64 64 0 010-90.496l362.048-362.048a64 64 0 0190.496 0z"></path></svg>
    )
  }
})


export const ArrowRight = defineComponent({
  name: 'icon-arrow-right',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 000 42.752L652.736 512 340.864 831.872a30.592 30.592 0 000 42.752 29.12 29.12 0 0041.728 0L714.24 534.336a32 32 0 000-44.672L382.592 149.376a29.12 29.12 0 00-41.728 0z"></path></svg>
    )
  }
})

export const ArrowRightBold = defineComponent({
  name: 'icon-arrow-right-bold',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M338.752 104.704a64 64 0 000 90.496l316.8 316.8-316.8 316.8a64 64 0 0090.496 90.496l362.048-362.048a64 64 0 000-90.496L429.248 104.704a64 64 0 00-90.496 0z"></path></svg>
    )
  }
})


export const ArrowUp = defineComponent({
  name: 'icon-arrow-up',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M488.832 344.32l-339.84 356.672a32 32 0 000 44.16l.384.384a29.44 29.44 0 0042.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0042.688 0l.384-.384a32 32 0 000-44.16L535.168 344.32a32 32 0 00-46.336 0z"></path></svg>
    )
  }
})

export const ArrowUpBold = defineComponent({
  name: 'icon-arrow-up-bold',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M104.704 685.248a64 64 0 0090.496 0l316.8-316.8 316.8 316.8a64 64 0 0090.496-90.496L557.248 232.704a64 64 0 00-90.496 0L104.704 594.752a64 64 0 000 90.496z"></path></svg>
    )
  }
})

export const Back = defineComponent({
  name: 'icon-back',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M224 480h640a32 32 0 110 64H224a32 32 0 010-64z"></path><path fill="currentColor" d="M237.248 512l265.408 265.344a32 32 0 01-45.312 45.312l-288-288a32 32 0 010-45.312l288-288a32 32 0 1145.312 45.312L237.248 512z"></path></svg>
    )
  }
})

export const Bottom = defineComponent({
  name: 'icon-bottom',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M544 805.888V168a32 32 0 10-64 0v637.888L246.656 557.952a30.72 30.72 0 00-45.312 0 35.52 35.52 0 000 48.064l288 306.048a30.72 30.72 0 0045.312 0l288-306.048a35.52 35.52 0 000-48 30.72 30.72 0 00-45.312 0L544 805.824z"></path></svg>
    )
  }
})

export const Circle = defineComponent({
  name: 'icon-circle',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"></path>
      </svg>
    )
  }
})

export const CircleCheck = defineComponent({
  name: 'icon-circle-check',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"></path><path fill="currentColor" d="M745.344 361.344a32 32 0 0145.312 45.312l-288 288a32 32 0 01-45.312 0l-160-160a32 32 0 1145.312-45.312L480 626.752l265.344-265.408z"></path></svg>
    )
  }
})

export const CircleCheckFilled = defineComponent({
  name: 'icon-circle-check-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 10-54.336 54.336l126.72 126.72a38.272 38.272 0 0054.336 0l262.4-262.464a38.4 38.4 0 10-54.272-54.336L456.192 600.384z"></path></svg>
    )
  }
})

export const CircleClose = defineComponent({
  name: 'icon-circle-close',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M466.752 512l-90.496-90.496a32 32 0 0145.248-45.248L512 466.752l90.496-90.496a32 32 0 1145.248 45.248L557.248 512l90.496 90.496a32 32 0 11-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 01-45.248-45.248L466.752 512z"></path><path fill="currentColor" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"></path></svg>
    )
  }
})

export const CircleCloseFilled = defineComponent({
  name: 'icon-circle-close-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 393.664L407.936 353.6a38.4 38.4 0 10-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1054.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1054.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 10-54.336-54.336L512 457.664z"></path></svg>
    )
  }
})

export const CirclePlus = defineComponent({
  name: 'icon-circle-plus',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M352 480h320a32 32 0 110 64H352a32 32 0 010-64z"></path><path fill="currentColor" d="M480 672V352a32 32 0 1164 0v320a32 32 0 01-64 0z"></path><path fill="currentColor" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"></path></svg>
    )
  }
})



export const CirclePlusFilled = defineComponent({
  name: 'icon-circle-plus-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zm-38.4 409.6H326.4a38.4 38.4 0 100 76.8h147.2v147.2a38.4 38.4 0 0076.8 0V550.4h147.2a38.4 38.4 0 000-76.8H550.4V326.4a38.4 38.4 0 10-76.8 0v147.2z"></path></svg>
    )
  }
})


export const Close = defineComponent({
  name: 'icon-close',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M764.288 214.592L512 466.88 259.712 214.592a31.936 31.936 0 00-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1045.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0045.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 10-45.12-45.184z"></path></svg>
    )
  }
})


export const CloseBold = defineComponent({
  name: 'icon-close-bold',
  setup() {
    return () => (<svg

      width="20"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M195.2 195.2a64 64 0 0190.496 0L512 421.504 738.304 195.2a64 64 0 0190.496 90.496L602.496 512 828.8 738.304a64 64 0 01-90.496 90.496L512 602.496 285.696 828.8a64 64 0 01-90.496-90.496L421.504 512 195.2 285.696a64 64 0 010-90.496z"
      />
    </svg>)
  }
})




export const Drill = defineComponent({
  name: 'icon-drill',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
        <path fill="#fff" stroke-width="17" fill-opacity="0" opacity="NaN" d="M228.99105680842993,25.414990552240276 L831.3456539413713,22.71384886106115 L696.2885693824159,225.2994756994944 L531.5189262204902,727.7118302588088 L342.4390078379525,219.8971923171362 L228.99105680842993,25.414990552240276 z" stroke="currentColor"></path>
        <path fill="#fff" stroke-width="17" fill-opacity="0" opacity="NaN" d="M520.7143594557739,22.71384886106115 L345.1401495291317,222.5983340083153 L228.99105680842993,22.71384886106115 L85.8305471759371,222.5983340083153 L526.116642838132,733.1141136411671 L958.2993134267896,222.5983340083153 L825.9433705590134,25.414990552240276 L696.2885693824159,222.5983340083153 L520.7143594557739,22.71384886106115 z" stroke="currentColor"></path>
        <line fill="none" stroke-width="17" fill-opacity="0" x1="80.42826379357889" y1="219.8971923171362" x2="961.0004551179688" y2="217.19605062595704" stroke="currentColor"></line>
      </svg>
    )
  }
})


export const DrillFilled = defineComponent({
  name: 'icon-drill-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
        <g id="svg_12" stroke="null">
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M238.12913522011627,22.000064849853516 C238.12913522011627,22.000064849853516 320.9150841002983,173.77430446352056 320.9150841002983,173.77430446352056 C320.9150841002983,173.77430446352056 456.13213393792887,22.000064849853516 456.13213393792887,22.000064849853516 C456.13213393792887,22.000064849853516 238.12913522011627,22.000064849853516 238.12913522011627,22.000064849853516 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M163.62178122795245,46.83584951390812 L56.000047683715835,187.57196261021755 L274.0030464015285,195.85055749823576 L163.62178122795245,46.83584951390812 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M527.8799563007534,38.557254625889925 L381.6247799457651,201.36962075691451 L674.1351326557416,201.36962075691451 L527.8799563007534,38.557254625889925 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M883.8595364855361,57.87397603126573 L781.7568661999783,195.85055749823576 L997.0003332884514,204.12915238625396 L883.8595364855361,57.87397603126573 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M75.31676908909164,245.52212682634493 L439.5749441618926,692.5662507793279 L298.8388310655831,245.52212682634493 L75.31676908909164,245.52212682634493 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M751.4020182772448,264.8388482317208 L591.3491837755596,681.5281242619703 L972.1645486243968,273.11744311973905 L751.4020182772448,264.8388482317208 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M365.0675901697287,251.04119008502383 L514.0822981540564,736.7187568487584 L693.4518540611175,256.5602533437025 L365.0675901697287,251.04119008502383 z"></path>
          <path fill="currentColor" stroke="#000" opacity="NaN" d="M605.1468419222566,24.759596479192915 C605.1468419222566,24.759596479192915 831.4284355280873,27.519128108532318 831.4284355280873,27.519128108532318 C831.4284355280873,27.519128108532318 732.085296871869,182.05289935153877 732.085296871869,182.05289935153877 C732.085296871869,182.05289935153877 605.1468419222566,24.759596479192915 605.1468419222566,24.759596479192915 z"></path>
        </g>
      </svg>
    )
  }
})



export const Minus = defineComponent({
  name: 'icon-minus',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M128 448h768q64 0 64 64t-64 64H128q-64 0-64-64t64-64z"></path></svg>
    )
  }
})




export const Plus = defineComponent({
  name: 'icon-plus',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M480 480V128a32 32 0 0164 0v352h352a32 32 0 110 64H544v352a32 32 0 11-64 0V544H128a32 32 0 010-64h352z"></path></svg>
    )
  }
})


export const Remove = defineComponent({
  name: 'icon-remove',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M352 480h320a32 32 0 110 64H352a32 32 0 010-64z"></path><path fill="currentColor" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"></path></svg>
    )
  }
})

export const RemoveFilled = defineComponent({
  name: 'icon-remove-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zM288 512a38.4 38.4 0 0038.4 38.4h371.2a38.4 38.4 0 000-76.8H326.4A38.4 38.4 0 00288 512z"></path></svg>
    )
  }
})


export const Select = defineComponent({
  name: 'icon-select',
  setup() {
    return () => (
      <svg

        width="20"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M77.248 415.04a64 64 0 0190.496 0l226.304 226.304L846.528 188.8a64 64 0 1190.56 90.496l-543.04 543.04-316.8-316.8a64 64 0 010-90.496z"
        />
      </svg>
    )
  }
})


export const Star = defineComponent({
  name: 'icon-arrow-down',
  setup() {
    return () => (
      <svg
        width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" >
        <path fill="currentColor" d="m512 747.84 228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72L512 747.84zM313.6 924.48a70.4 70.4 0 0 1-102.144-74.24l37.888-220.928L88.96 472.96A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 126.208 0l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z"></path>

      </svg>)
  }
})



export const StarFilled = defineComponent({
  name: 'icon-arrow-down',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" >
        <path fill="currentColor" d="M 313.6 924.48 A 70.4 70.4 0 0 1 211.456 850.24 L 249.344 629.312 L 88.96 472.96 A 70.4 70.4 0 0 1 128 352.896 L 349.76 320.64 L 448.96 119.68 A 70.4 70.4 0 0 1 575.168 119.68 L 674.368 320.64 L 896.192 352.896 A 70.4 70.4 0 0 1 935.232 472.96 L 774.72 629.376 L 812.608 850.304 A 70.4 70.4 0 0 1 710.464 924.544 L 512 820.096 L 313.6 924.416 L 313.6 924.48 z"></path>
      </svg>)
  }
})


export const Top = defineComponent({
  name: 'icon-top',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M572.235 205.282v600.365a30.118 30.118 0 11-60.235 0V205.282L292.382 438.633a28.913 28.913 0 01-42.646 0 33.43 33.43 0 010-45.236l271.058-288.045a28.913 28.913 0 0142.647 0L834.5 393.397a33.43 33.43 0 010 45.176 28.913 28.913 0 01-42.647 0l-219.618-233.23z"></path></svg>
    )
  }
})


export const trigBottom = defineComponent({
  name: 'icon-trig-bottom',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M192 384l320 384 320-384z"></path></svg>
    )
  }
})


export const trigLeft = defineComponent({
  name: 'icon-trig-left',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M672 192L288 511.936 672 832z"></path></svg>
    )
  }
})

export const trigRight = defineComponent({
  name: 'icon-trig-right',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M384 192v640l384-320.064z"></path></svg>
    )
  }
})


export const trigTop = defineComponent({
  name: 'icon-trig-top',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 320L192 704h639.936z"></path></svg>
    )
  }
})

export const User = defineComponent({
  name: 'icon-arrow-down',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" ><path fill="currentColor" d="M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384zm0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512zm320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0z"></path></svg>
    )
  }
})

export const UserFilled = defineComponent({
  name: 'icon-arrow-down',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" ><path fill="currentColor" d="M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"></path></svg>
    )
  }
})

export const Warning = defineComponent({
  name: 'icon-warning',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 832a384 384 0 000-768 384 384 0 000 768zm48-176a48 48 0 11-96 0 48 48 0 0196 0zm-48-464a32 32 0 0132 32v288a32 32 0 01-64 0V288a32 32 0 0132-32z"></path></svg>
    )
  }
})


export const WarningFilled = defineComponent({
  name: 'icon-warning-filled',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 192a58.432 58.432 0 00-58.24 63.744l23.36 256.384a35.072 35.072 0 0069.76 0l23.296-256.384A58.432 58.432 0 00512 256zm0 512a51.2 51.2 0 100-102.4 51.2 51.2 0 000 102.4z"></path></svg>
    )
  }
})


export const RectEdit = defineComponent({
  name: 'icon-rect-edit',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" ><path fill="currentColor" d="M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640V512z"></path><path fill="currentColor" d="m469.952 554.24 52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"></path></svg>)
  }
})

// 抄送
export const Promotion = defineComponent({
  name: 'icon-promotion',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m64 448 832-320-128 704-446.08-243.328L832 192 242.816 545.472 64 448zm256 512V657.024L512 768 320 960z"></path></svg>
    )
  }
})

// 审批
export const Stamp = defineComponent({
  name: 'icon-stamp',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M624 475.968V640h144a128 128 0 0 1 128 128H128a128 128 0 0 1 128-128h144V475.968a192 192 0 1 1 224 0zM128 896v-64h768v64H128z"></path></svg>)
  }
})

// copy
export const DocumentCopy = defineComponent({
  name: 'icon-document-Copy',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path></svg>)
  }
})

// 分支
export const Branch = defineComponent({
  name: 'icon-branch',
  setup() {
    return () => (
      <svg viewBox="0 0 1024 1024" width="15" xmlns="http://www.w3.org/2000/svg" color="#15BC83"><rect id="svg_5" height="195" width="195" y="200.4616" x="412" stroke="#000" fill="currentColor"></rect><line stroke="currentColor" stroke-width="20" id="svg_6" y2="475.46801" x2="512" y1="388.46161" x1="512" fill="none"></line><line stroke="currentColor" id="svg_7" y2="473.4616" x2="899.99998" y1="473.4616" x1="123.00001" stroke-width="20" fill="none"></line><path stroke="currentColor" id="svg_8" d="m126.99803,462.89638l0,122.00892" opacity="undefined" stroke-width="20" fill="none"></path><rect id="svg_11" height="195" width="195" y="578.79828" x="30" stroke="#000" fill="currentColor"></rect><path stroke="currentColor" id="svg_13" d="m894.2589,463.76594l0,122.00892" opacity="undefined" stroke-width="20" fill="none"></path><rect id="svg_14" height="195" width="195" y="582.0433" x="797.93815" stroke="#000" fill="currentColor"></rect><rect id="svg_15" height="195" width="195" y="579.66784" x="415.6241" stroke="#000" fill="currentColor"></rect></svg>)
  }
})



// export const RightArrowSingle = defineComponent({
//   name: 'icon-right-arrow-single',
//   setup() {
//     return () => (
//       <svg width="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
//         <rect fill="currentColor" x="55.99977910509324" y="508.0192999244516" width="916.0003821851418" height="28.000000000000014" id="svg_4" stroke="#000000"></rect>
//         <path fill="currentColor" d="M825.9651416406776,508.0554081386744 L825.9651416406776,464.0553921728516 L965.9652386526108,508.0554081386744 L825.9651416406776,508.0554081386744 z" id="svg_5" stroke="#000000"></path>
//       </svg>
//       )
//     }
// })


export const LangArrow = defineComponent({
  name: 'icon-lang-arrow',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M10.661141 504.070139h916.057631v27.284566H10.661141V504.070139z"></path>
        <path fill="currentColor" d="M926.749468 483.350715v48.00399h87.652681l-87.652681-48.00399z"></path>
      </svg>
    )
  }
})


export const RightArrowSingle = defineComponent({
  name: 'icon-right-arrow-single',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M693.459627 499.841707l-83.41504-48.16896c-20.486827-11.646293-27.651413-37.69344-16.001707-58.180267 11.646293-20.486827 37.69344-27.648 58.180267-16.001707l0.49152 0.283307 217.173333 125.44c21.701973 9.171627 31.873707 34.2016 22.70208 55.906987a42.7008 42.7008 0 0 1-11.871573 16.073386 42.550613 42.550613 0 0 1-32 9.987414H170.666667c-23.56224 0-42.666667-19.10784-42.666667-42.666667 0-23.56224 19.104427-42.666667 42.666667-42.666667l522.79296-0.006826z">
        </path>
      </svg>
    )
  }
})


export const RightArrowDouble = defineComponent({
  name: 'icon-right-arrow-double',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M693.459627 383.788373l-83.41504-48.16896c-20.483413-11.646293-27.648-37.69344-16.001707-58.180266s37.69344-27.648 58.180267-16.001707l0.488106 0.283307 217.173334 125.44c21.705387 9.168213 31.873707 34.198187 22.705493 55.906986a42.728107 42.728107 0 0 1-11.86816 16.073387 42.550613 42.550613 0 0 1-32 9.984H170.666667c-23.56224 0-42.666667-19.104427-42.666667-42.666667s19.104427-42.666667 42.666667-42.666666h522.79296zM330.53696 640.21504l83.41504 48.16896c20.329813 11.915947 27.149653 38.055253 15.230293 58.385067-11.80672 20.135253-37.604693 27.050667-57.89696 15.5136l-217.173333-125.44c-21.705387-9.171627-31.870293-34.198187-22.70208-55.906987a42.656427 42.656427 0 0 1 11.86816-16.073387 42.530133 42.530133 0 0 1 32-9.984H853.333333c23.56224 0 42.666667 19.104427 42.666667 42.666667s-19.104427 42.666667-42.666667 42.666667H330.53696z">
        </path>
      </svg>
    )
  }
})


export const FilterDate = defineComponent({
  name: 'icon-filter-date',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M716.78 972.805A51.195 51.195 0 0 1 665.585 1024a50.99 50.99 0 0 1-50.94-51.195v-529.15l241.59-254.746a51.246 51.246 0 0 0-37.066-86.52H204.831a51.246 51.246 0 0 0-37.117 86.469l242.203 254.797v273.892a51.195 51.195 0 0 1-102.39 0V484.56L93.534 259.404A153.585 153.585 0 0 1 204.831 0h614.338a153.585 153.585 0 0 1 111.196 259.507L716.78 484.61v488.194z">
        </path>
      </svg>
    )
  }
})


export const CircleGapDate = defineComponent({
  name: 'icon-circle-gap-date',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M891.392 351.744c-20.48-49.152-50.176-93.184-88.064-130.56-37.888-37.888-81.92-67.584-130.56-88.064-50.688-21.504-104.448-32.256-160.256-32.256S402.944 111.616 352.256 133.12c-49.152 20.48-93.184 50.176-130.56 88.064S153.6 302.592 132.608 351.744c-21.504 50.688-32.256 104.448-32.256 160.256s10.752 109.568 32.256 160.256c6.144 14.848 13.312 28.672 20.992 42.496l50.176-33.792c-27.648-50.176-43.52-107.52-43.52-168.96 0-194.048 157.696-351.744 351.744-351.744s351.744 157.696 351.744 351.744-157.696 351.744-351.744 351.744c-65.536 0-126.464-17.92-179.2-49.152l-33.792 49.664c16.896 10.24 34.304 19.456 52.736 27.136 50.688 21.504 104.448 32.256 160.256 32.256s109.568-10.752 160.256-32.256c49.152-20.48 93.184-50.176 130.56-88.064 37.888-37.888 67.584-81.92 88.064-130.56 21.504-50.688 32.256-104.448 32.256-160.256s-10.752-110.08-31.744-160.768z">
        </path>
        <path fill="currentColor"
          d="M684.032 370.688c-9.216-19.456-28.16-31.744-50.176-31.744H390.144c-21.504 0-40.448 12.288-50.176 31.744s-6.656 41.984 7.168 58.88l65.536 80.896v193.024c0 16.384 13.312 30.208 30.208 30.208s30.208-13.312 30.208-30.208V499.2c0-6.656-2.56-13.312-6.656-18.944l-66.56-81.408h224.256L558.08 480.256c-4.096 5.12-6.656 11.776-6.656 18.944v143.36c0 16.384 13.312 30.208 30.208 30.208s30.208-13.312 30.208-30.208v-133.12l65.536-80.896c13.312-15.872 15.872-38.4 6.656-57.856z">
        </path>
        <path fill="currentColor" d="M316.416 839.68m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
        <path fill="currentColor" d="M179.2 698.368m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
      </svg>
    )
  }
})


export const Calendar = defineComponent({
  name: 'icon-calendar',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M766.75632 129.467455h170.408532c47.026767 0 85.171767 38.145 85.171767 85.171767v724.188011c0 47.027767-38.145 85.172767-85.171767 85.172767H85.186191A85.172767 85.172767 0 0 1 0.013425 938.827233V214.639222c0-47.026767 38.145-85.171767 85.172766-85.171767h170.408532V44.294689a42.618883 42.618883 0 1 1 85.171767 0v85.172766h340.817063V44.294689a42.618883 42.618883 0 0 1 85.172767 0v85.172766z m0 85.171767v85.236765a42.618883 42.618883 0 0 1-85.172767 0v-85.236765H340.76649v85.236765a42.618883 42.618883 0 1 1-85.171767 0v-85.236765H85.186191v724.188011h851.977661V214.639222H766.75732zM85.186191 512.838403h851.977661v85.171767h-851.977661v-85.171767z">
        </path>
      </svg>
    )
  }
})



export const Order = defineComponent({
  name: 'icon-order',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M608 42.667a106.71 106.71 0 0 1 101.781 74.666h33.536c83.072 0 149.974 69.184 152.598 154.752l0.085 5.248v533.334c0 86.186-65.237 157.12-147.627 159.914l-5.056 0.086H280.683c-83.072 0-149.974-69.184-152.598-154.752l-0.085-5.248V277.333c0-86.186 65.237-157.12 147.627-159.914l5.056-0.086h33.536A106.71 106.71 0 0 1 416 42.667zM314.219 181.333h-33.536c-47.104 0-86.315 40.107-88.576 91.307l-0.107 4.693v533.334c0 51.84 37.824 93.482 84.416 95.893l4.267 0.107h462.634c47.104 0 86.315-40.107 88.576-91.307l0.107-4.693V277.333c0-51.84-37.824-93.482-84.416-95.893l-4.267-0.107H709.76A106.71 106.71 0 0 1 608 256H416a106.71 106.71 0 0 1-101.781-74.667z m379.114 437.334a32 32 0 0 1 0 64H330.667a32 32 0 0 1 0-64h362.666z m0-192a32 32 0 0 1 0 64H330.667a32 32 0 0 1 0-64h362.666z m-85.333-320H416A42.667 42.667 0 1 0 416 192h192a42.667 42.667 0 1 0 0-85.333z">
        </path>
      </svg>
    )
  }
})


export const CircleFillI = defineComponent({
  name: 'icon-circle-fill-i',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m0-93.11a418.89 418.89 0 1 0 0-837.78 418.89 418.89 0 0 0 0 837.78z m-46.519-543.013h93.038v403.382H465.48V387.877z m0-155.136h93.038v93.11H465.48v-93.11z">
        </path>
      </svg>
    )
  }
})


export const CircleFillDoubt = defineComponent({
  name: 'icon-circle-fill-doubt',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M512 64c247.424 0 448 200.576 448 448S759.424 960 512 960 64 759.424 64 512 264.576 64 512 64z m0 72c-207.66 0-376 168.34-376 376s168.34 376 376 376 376-168.34 376-376-168.34-376-376-376z">
        </path>
        <path fill="currentColor"
          d="M623.6 304.7C593.6 278.4 554 264 512 264s-81.6 14.5-111.6 40.7C369.2 332 352 368.7 352 408v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V408c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V608c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7c0-19.7 12.4-37.7 30.9-44.8 59-22.7 97.1-74.7 97.1-132.5 0.1-39.3-17.1-76-48.3-103.3zM472 720c0 22.091 17.909 40 40 40s40-17.909 40-40-17.909-40-40-40-40 17.909-40 40z">
        </path>
      </svg>
    )
  }
})


export const CircleUser = defineComponent({
  name: 'icon-circle-user',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M512 196.923a196.923 196.923 0 0 1 131.269 343.71 314.998 314.998 0 0 1 177.94 347.293 39.385 39.385 0 1 1-77.312-15.163 236.308 236.308 0 0 0-231.03-281.994h-1.733 0.866a236.308 236.308 0 0 0-231.897 281.994 39.385 39.385 0 1 1-77.312 15.163 315.116 315.116 0 0 1 177.94-347.372A196.923 196.923 0 0 1 512 196.924zM512.788 512a118.154 118.154 0 1 0-0.788 0h-0.788z">
        </path>
        <path fill="currentColor"
          d="M512 0C229.218 0 0 229.218 0 512s229.218 512 512 512 512-229.218 512-512S794.782 0 512 0z m0 78.77c239.262 0 433.23 193.968 433.23 433.23S751.263 945.23 512 945.23 78.77 751.263 78.77 512 272.737 78.77 512 78.77z">
        </path>
      </svg>
    )
  }
})


export const Edit = defineComponent({
  name: 'icon-edit',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M153.6 902.656a32.256 32.256 0 0 1 0-64h716.8a32.256 32.256 0 0 1 0 64zM743.936 151.04l72.192 72.192a51.2 51.2 0 0 1 0 72.192L358.4 751.616a51.2 51.2 0 0 1-36.352 14.848h-95.232a25.6 25.6 0 0 1-25.6-25.6v-97.792a51.2 51.2 0 0 1 14.848-36.352l455.68-455.68a51.2 51.2 0 0 1 72.192 0z m-478.72 497.152v54.272h54.272l442.88-442.88-54.272-54.784z">
        </path>
      </svg>
    )
  }
})


export const CircleFiledSpot = defineComponent({
  name: 'icon-circle-filed-spot',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M511.56992 38.25664c-259.36896 0-469.62688 210.25792-469.62688 469.62176 0 259.36896 210.25792 469.62176 469.62688 469.62176 259.36384 0 469.62176-210.2528 469.62176-469.62176 0-259.36384-210.25792-469.62176-469.62176-469.62176z m-215.0912 535.3984c-35.4304 0-64.1536-28.7232-64.1536-64.1536 0-35.4304 28.7232-64.15872 64.1536-64.15872 35.4304 0 64.1536 28.7232 64.1536 64.15872 0 35.4304-28.7232 64.1536-64.1536 64.1536z m215.49056-0.00512c-35.4304 0-64.1536-28.7232-64.1536-64.1536 0-35.4304 28.7232-64.1536 64.1536-64.1536s64.14848 28.7232 64.14848 64.1536c0 35.4304-28.71808 64.1536-64.14848 64.1536z m210.01728 0.00512c-35.4304 0-64.1536-28.7232-64.1536-64.1536s28.7232-64.1536 64.1536-64.1536c35.42528 0 64.14848 28.7232 64.14848 64.1536s-28.7232 64.1536-64.14848 64.1536z">
        </path>
      </svg>
    )
  }
})


export const Peoples = defineComponent({
  name: 'icon-peoples',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M787.443 1022.678c15.145 0 27.406-13.222 27.886-30.17l0.24-10.579h0.482c0.36-7.693 0.6-14.424 0.6-20.915 0-181.865-100.849-342.816-256.99-410.129l-17.55-7.572 15.506-11.18c74.765-54.09 119.36-144.482 119.36-241.605C676.977 130.298 556.775 0 408.927 0s-268.05 130.299-268.05 290.528c0 97.123 44.595 187.515 119.36 241.606l15.506 11.179-17.55 7.572C102.173 618.32 1.324 779.27 1.324 961.015c0 6.49 0.24 13.101 0.6 20.914h0.721l0.12 10.819c0 17.188 12.622 31.132 28.008 31.132 15.506 0.12 741.405-1.202 756.67-1.202m-68.875-453.041c70.198 8.414 133.664 44.715 179.221 102.532 45.316 57.577 70.318 133.184 70.318 212.878 0 17.55 12.862 31.733 28.608 31.733 15.266 0 27.767-13.343 28.368-30.411l0.12-0.962c0-0.12 0-0.36 0.12-0.48-0.24-151.335-84.141-285.12-213.96-341.013l-17.549-7.573 15.506-11.179c62.145-44.835 99.287-119.841 99.287-200.617 0-111.788-69.597-207.709-169.485-234.033l-0.6 0.24-2.765-0.24c-0.601 0-1.202-0.12-1.803-0.24-0.24 0-0.481-0.12-0.721-0.12-15.987 0-28.97 14.544-28.97 32.214 0 15.986 10.338 29.329 24.642 31.733l1.323 0.24 1.202 0.481c1.442 0.601 3.485 1.322 6.13 2.043 0.6 0.12 0.961 0.24 1.202 0.361 65.63 24.04 109.744 90.392 109.744 164.917 0 83.3-54.812 154.82-130.539 170.927l-1.202 0.721-2.524 0.12c-17.91 1.203-31.974 17.67-31.974 37.383 0 20.194 14.424 36.662 32.815 37.503l2.404 0.12 1.082 0.722m0 0">
        </path>
      </svg>
    )
  }
})


export const FilledSmallBell = defineComponent({
  name: 'icon-filled-small-bell',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M857.884 605.298v-179.77c0-157.012-104.675-291.27-252.586-325.404C593.92 56.89 555.236 27.307 512 27.307c-45.511 0-84.196 34.133-93.298 77.369-138.809 40.96-236.658 172.942-236.658 320.853V593.92A170.212 170.212 0 0 0 102.4 737.28v2.276c0 22.755 4.551 45.51 13.653 65.99l2.276 2.276c6.827 15.93 20.48 27.307 36.409 31.858 4.55 2.276 11.378 2.276 20.48 2.276h675.84c4.55 0 9.102 0 13.653-2.276 20.48-2.276 36.409-15.929 43.236-31.858 9.102-20.48 13.653-45.51 13.653-68.266v-2.276c0-52.338-22.756-100.124-63.716-131.982zM589.37 894.293H409.6c0 56.89 45.511 102.4 102.4 102.4s102.4-45.51 102.4-102.4h-25.031z">
        </path>
      </svg>
    )
  }
})



export const FilledTrain = defineComponent({
  name: 'icon-filled-train',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M680.448 244.224c61.44 0 111.616 49.664 111.616 111.616v283.136c0 48.64-30.72 89.6-74.24 104.96l58.368 113.152c5.12 10.24 1.024 23.04-9.216 28.16-2.56 1.536-5.632 2.048-8.192 2.048h-23.04c-7.168 0-14.336-4.096-17.92-10.24l-0.512-1.024-17.92-34.304H331.776l-17.92 34.304c-3.584 7.168-10.752 11.264-18.432 11.264h-22.016c-11.776 0-20.992-9.216-20.992-20.992 0-3.584 1.024-6.656 2.56-9.728l58.368-113.152c-43.008-15.36-74.24-56.32-74.24-104.96V355.328c0-61.44 49.664-111.616 111.616-111.616h329.728z m-28.672 505.856H378.88l-23.552 45.568h320l-23.552-45.568z m-297.472-168.96c-25.088 0-45.568 20.48-45.568 45.056 0 25.088 20.48 45.056 45.568 45.056s45.568-20.48 45.568-45.056c0-24.576-20.48-45.056-45.568-45.056z m322.048 0c-25.088 0-45.568 20.48-45.568 45.056 0 25.088 20.48 45.056 45.568 45.056s45.568-20.48 45.568-45.056c0-24.576-20.48-45.056-45.568-45.056z m-10.24-253.44H364.544c-30.72 0-55.808 25.088-55.808 55.808v86.528c0 30.72 25.088 55.808 55.808 55.808h301.568c30.72 0 55.808-25.088 55.808-55.808V383.488c0-30.72-25.088-55.808-55.808-55.808zM618.496 186.368c0 15.872-12.8 28.672-28.672 28.672H442.88c-15.872 0-28.672-12.8-28.672-28.672 0-15.872 12.8-28.672 28.672-28.672h147.456c15.36 0 28.16 12.8 28.16 28.672z">
        </path>
      </svg>
    )
  }
})


export const FilledCar = defineComponent({
  name: 'icon-filled-car',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M941.435 801.863V695.65c22.56-32.598 34.679-73.414 34.679-118.428 0-71.757-29.913-133.51-86.59-165.948C873.37 279.864 800.858 183.43 711.209 183.43H312.823c-89.68 0-162.194 96.432-178.413 227.844-56.61 32.407-86.525 94.192-86.525 165.948 0 45.014 12.243 85.83 34.679 118.428v106.212c0 51.61 189.331 51.61 189.331 0v-34.315h480.363v34.315c0.002 51.608 189.177 51.608 189.177 0M208.25 639.039c-34.143 0-61.785-27.625-61.785-61.816 0-34.19 27.674-61.879 61.785-61.879 34.332 0 61.848 27.69 61.848 61.88s-27.643 61.815-61.848 61.815m22.184-252.236c-12.369 0-23.635 1.498-34.68 3.17 17.798-86.303 64.215-149.839 117.196-149.839h398.416c52.95 0 99.273 63.536 117.07 149.84-5.806-0.931-12.214-1.231-18.43-1.673 0.002-0.52-579.572-1.498-579.572-1.498m585.379 252.236c-34.205 0-61.88-27.625-61.88-61.816 0-34.19 27.8-61.879 61.88-61.879 34.081 0 61.784 27.69 61.784 61.88 0.16 34.19-27.64 61.815-61.784 61.815">
        </path>
      </svg>
    )
  }
})


export const FilledFlight = defineComponent({
  name: 'icon-filled-flight',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M824.32 453.12l-228.864 60.416L383.488 358.4l-106.496 0.512 161.28 205.312-124.928 36.864s-128-76.288-137.728-77.824c-9.728-1.536-13.824 7.68-16.384 17.92-2.56 11.264 4.608 31.744 4.608 31.744s109.568 110.08 131.072 115.2c21.504 4.608 80.896 2.048 124.928-9.216 43.52-11.264 250.88-70.656 340.48-107.52 89.6-35.84 115.2-56.832 115.2-56.832s2.56-21.504-8.192-41.472c-11.776-19.456-43.008-19.968-43.008-19.968z">
        </path>
      </svg>
    )
  }
})


export const CircleGapClock = defineComponent({
  name: 'icon-circle-gap-clock',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M512 929.96C281.6 929.96 94.04 742.4 94.04 512S281.6 94.04 512 94.04 929.96 281.6 929.96 512 742.4 929.96 512 929.96z m0-794.123c-207.412 0-376.163 168.75-376.163 376.163S304.587 888.163 512 888.163 888.163 719.413 888.163 512 719.413 135.837 512 135.837z">
        </path>
        <path fill="currentColor"
          d="M718.367 538.122h-208.98c-11.493 0-20.897-9.404-20.897-20.898s9.404-20.897 20.898-20.897h208.98c11.493 0 20.897 9.404 20.897 20.897s-9.404 20.898-20.898 20.898z">
        </path>
        <path fill="currentColor"
          d="M509.388 538.122c-11.494 0-20.898-9.404-20.898-20.898V256c0-11.494 9.404-20.898 20.898-20.898s20.898 9.404 20.898 20.898v261.224c0 11.494-9.404 20.898-20.898 20.898z">
        </path>
      </svg>
    )
  }
})

export const CircleClock = defineComponent({
  name: 'icon-circle-clock',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M891.392 351.744c-20.48-49.152-50.176-93.184-88.064-130.56-37.888-37.888-81.92-67.584-130.56-88.064-50.688-21.504-104.448-32.256-160.256-32.256S402.944 111.616 352.256 133.12c-49.152 20.48-93.184 50.176-130.56 88.064S153.6 302.592 132.608 351.744c-21.504 50.688-32.256 104.448-32.256 160.256s10.752 109.568 32.256 160.256c6.144 14.848 13.312 28.672 20.992 42.496l50.176-33.792c-27.648-50.176-43.52-107.52-43.52-168.96 0-194.048 157.696-351.744 351.744-351.744s351.744 157.696 351.744 351.744-157.696 351.744-351.744 351.744c-65.536 0-126.464-17.92-179.2-49.152l-33.792 49.664c16.896 10.24 34.304 19.456 52.736 27.136 50.688 21.504 104.448 32.256 160.256 32.256s109.568-10.752 160.256-32.256c49.152-20.48 93.184-50.176 130.56-88.064 37.888-37.888 67.584-81.92 88.064-130.56 21.504-50.688 32.256-104.448 32.256-160.256s-10.752-110.08-31.744-160.768z">
        </path>
        <path fill="currentColor" d="M316.416 839.68m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
        <path fill="currentColor" d="M179.2 698.368m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
        <path fill="currentColor"
          d="M541.184 504.832c0 16.896-13.312 30.208-30.208 30.208-16.896 0-30.208-13.824-30.208-30.208v-153.6c0-16.896 13.312-30.208 30.208-30.208 16.896 0 30.208 13.312 30.208 30.208v153.6z">
        </path>
        <path fill="currentColor"
          d="M685.568 624.128c12.288 11.264 13.312 30.208 2.048 42.496-11.264 12.288-30.208 13.312-42.496 2.048l-154.112-140.288c-12.288-11.264-13.312-30.208-2.048-42.496 11.264-12.288 30.208-13.312 42.496-2.048l154.112 140.288z">
        </path>
      </svg>
    )
  }
})


export const ShareArrow = defineComponent({
  name: 'icon-share-arrow',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M360.96 182.784h46.08v545.28h-46.08z"></path>
        <path fill="currentColor" d="M361.472 682.496h277.504v46.08H361.472zM638.976 634.368v142.336l90.624-71.68z"></path>
      </svg>
    )
  }
})


export const ChangeFlight = defineComponent({
  name: 'icon-change-flight',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M515.584 74.24c-150.528 0-283.136 76.288-361.472 192.512l61.952 26.112c67.072-93.184 176.128-153.6 299.52-153.6 189.44 0 345.6 142.848 367.104 326.656l67.072 1.024c-22.016-220.672-208.384-392.704-434.176-392.704zM515.584 878.08c-204.288 0-369.664-165.376-369.664-369.664 0-4.608 0-9.216 0.512-13.824l-66.56-1.536c0 5.632-0.512 11.264-0.512 16.896 0 240.64 195.072 436.224 436.224 436.224 166.912 0 311.808-93.696 385.024-231.424l-62.976-25.088c-63.488 112.64-183.808 188.416-322.048 188.416z">
        </path>
        <path fill="currentColor"
          d="M742.4 450.048l-168.96 44.544-156.672-114.176-78.848 0.512L457.216 532.48l-92.16 27.136s-94.72-56.32-101.888-57.344-10.24 5.632-12.288 13.312c-2.048 8.192 3.584 23.552 3.584 23.552s80.896 81.408 96.768 84.992c15.872 3.584 59.904 1.536 92.16-6.656 32.256-8.192 185.344-52.224 251.392-79.36 66.048-26.624 84.992-41.984 84.992-41.984s2.048-15.872-6.144-30.72-31.232-15.36-31.232-15.36z">
        </path>
        <path fill="currentColor" d="M185.344 279.04m-33.792 0a33.792 33.792 0 1 0 67.584 0 33.792 33.792 0 1 0-67.584 0Z"></path>
        <path fill="currentColor" d="M868.864 701.952m-33.792 0a33.792 33.792 0 1 0 67.584 0 33.792 33.792 0 1 0-67.584 0Z"></path>
        <path fill="currentColor"
          d="M85.504 414.72s-4.096 28.16-4.608 40.96-1.536 39.936-1.536 39.936l108.032 17.92L85.504 414.72zM946.176 544.768s3.072-28.16 3.072-40.96-0.512-39.936-0.512-39.936L835.072 450.56l111.104 94.208z">
        </path>
      </svg>
    )
  }
})


export const FilledWechat = defineComponent({
  name: 'icon-filled-Wechat',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M395.846 603.585c-3.921 1.98-7.936 2.925-12.81 2.925-10.9 0-19.791-5.85-24.764-14.625l-2.006-3.864-78.106-167.913c-0.956-1.98-0.956-3.865-0.956-5.845 0-7.83 5.928-13.68 13.863-13.68 2.965 0 5.928 0.944 8.893 2.924l91.965 64.43c6.884 3.864 14.82 6.79 23.708 6.79 4.972 0 9.85-0.945 14.822-2.926L861.71 282.479c-77.149-89.804-204.684-148.384-349.135-148.384-235.371 0-427.242 157.158-427.242 351.294 0 105.368 57.361 201.017 147.323 265.447 6.88 4.905 11.852 13.68 11.852 22.45 0 2.925-0.957 5.85-2.006 8.775-6.881 26.318-18.831 69.334-18.831 71.223-0.958 2.92-2.013 6.79-2.013 10.75 0 7.83 5.929 13.68 13.865 13.68 2.963 0 5.928-0.944 7.935-2.925l92.922-53.674c6.885-3.87 14.82-6.794 22.756-6.794 3.916 0 8.889 0.944 12.81 1.98 43.496 12.644 91.012 19.53 139.48 19.53 235.372 0 427.24-157.158 427.24-351.294 0-58.58-17.78-114.143-48.467-163.003l-491.39 280.07-2.963 1.98z"
        ></path>
      </svg>
    )
  }
})


export const CircleGapFliter = defineComponent({
  name: 'icon-circle-gap-fliter',
  setup() {
    return () => (
      <svg width="20" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
          d="M891.392 351.744c-20.48-49.152-50.176-93.184-88.064-130.56-37.888-37.888-81.92-67.584-130.56-88.064-50.688-21.504-104.448-32.256-160.256-32.256S402.944 111.616 352.256 133.12c-49.152 20.48-93.184 50.176-130.56 88.064S153.6 302.592 132.608 351.744c-21.504 50.688-32.256 104.448-32.256 160.256s10.752 109.568 32.256 160.256c6.144 14.848 13.312 28.672 20.992 42.496l50.176-33.792c-27.648-50.176-43.52-107.52-43.52-168.96 0-194.048 157.696-351.744 351.744-351.744s351.744 157.696 351.744 351.744-157.696 351.744-351.744 351.744c-65.536 0-126.464-17.92-179.2-49.152l-33.792 49.664c16.896 10.24 34.304 19.456 52.736 27.136 50.688 21.504 104.448 32.256 160.256 32.256s109.568-10.752 160.256-32.256c49.152-20.48 93.184-50.176 130.56-88.064 37.888-37.888 67.584-81.92 88.064-130.56 21.504-50.688 32.256-104.448 32.256-160.256s-10.752-110.08-31.744-160.768z">
        </path>
        <path fill="currentColor" d="M316.416 839.68m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
        <path fill="currentColor" d="M179.2 698.368m-30.208 0a30.208 30.208 0 1 0 60.416 0 30.208 30.208 0 1 0-60.416 0Z"></path>
        <path fill="currentColor"
          d="M515.072 427.52c11.264 12.288 9.728 31.744-2.56 43.008s-31.744 9.728-43.008-2.56L368.128 352.768c-11.264-12.288-9.728-31.744 2.56-43.008s31.744-9.728 43.008 2.56l101.376 115.2z">
        </path>
        <path fill="currentColor"
          d="M693.248 462.848c0 16.384-13.312 29.696-29.696 29.696H373.248c-16.384 0-29.696-13.312-29.696-29.696 0-16.384 13.312-29.696 29.696-29.696h289.792c16.896 0 30.208 13.312 30.208 29.696zM693.248 575.488c0 16.384-13.312 29.696-29.696 29.696H373.76c-16.384 0-29.696-13.312-29.696-29.696 0-16.384 13.312-29.696 29.696-29.696h289.792c16.384 0 29.696 13.312 29.696 29.696z">
        </path>
        <path fill="currentColor"
          d="M552.96 708.608c0 16.896-13.824 30.208-30.208 30.208-16.896 0-30.208-13.824-30.208-30.208V495.104c0-16.896 13.824-30.208 30.208-30.208 16.896 0 30.208 13.824 30.208 30.208v213.504z">
        </path>
        <path fill="currentColor"
          d="M565.248 469.504c-10.752 12.8-29.696 14.848-42.496 4.096-12.8-10.752-14.848-29.696-4.096-42.496L616.448 312.32c10.752-12.8 29.696-14.848 42.496-4.096 12.8 10.752 14.848 29.696 4.096 42.496l-97.792 118.784z">
        </path>
      </svg>
    )
  }
})

export const Search = defineComponent({
  name: 'icon-search',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M450.1 835.4C237.2 835.4 64 662.5 64 449.9S237.2 64.4 450.1 64.4c212.9 0 386.2 172.9 386.2 385.5S663.1 835.4 450.1 835.4m0-676.1C289.6 159.3 159 289.7 159 449.9c0 160.3 130.6 290.7 291.1 290.7 160.5 0 291.1-130.4 291.1-290.7 0-160.2-130.5-290.6-291.1-290.6" p-id="1393"></path>
        <path fill="currentColor" d="M901.2 958.6c-15.5 0-30.4-6.1-41.4-17.1L658.1 740.1c-22.3-22.9-22-59.4 0.6-82s59.2-22.8 82.1-0.6l201.8 201.4c16.7 16.7 21.7 41.8 12.6 63.6-9.1 21.9-30.4 36.1-54 36.1" p-id="1394"></path></svg>
    )
  }
})

export const Home = defineComponent({
  name: 'icon-home',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M107.715 534.619c-9.321 0-17.476-3.495-24.467-10.485-13.981-13.981-13.981-36.117 0-48.933L436.269 122.18c1.165-1.165 2.331-2.331 3.495-2.331 27.962-22.137 96.702-48.933 159.617 0 1.165 1.165 2.331 1.165 3.495 2.331l347.195 341.37c13.981 13.981 13.981 36.117 0 48.933-13.981 13.981-36.117 13.981-48.933 0l-348.361-339.04c-31.457-23.301-62.914-4.66-71.07 0l-349.525 350.69c-6.991 6.991-16.311 10.485-24.467 10.485z" p-id="1533"></path>
        <path fill="currentColor" d="M758.998 916.766H281.314c-31.457-1.165-78.061-25.632-78.061-82.721V528.793c0-19.807 15.146-34.953 34.953-34.953s34.953 15.146 34.953 34.953v305.252c0 4.66 0 11.651 11.651 12.816H759c8.156-1.165 9.321-6.991 10.485-13.981V529.958c0-19.807 15.146-34.953 34.953-34.953s34.953 15.146 34.953 34.953v306.417c-3.495 59.42-50.098 80.39-80.39 80.39z" p-id="1534"></path></svg>
    )
  }
})

export const UserCircleFilled = defineComponent({
  name: 'icon-user-circle-filled',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M513.37216 13.65504C238.14144 13.65504 15.02208 236.7744 15.02208 512c0 275.23072 223.11936 498.34496 498.35008 498.34496 275.23584 0 498.35008-223.11424 498.35008-498.34496 0-275.2256-223.11936-498.34496-498.35008-498.34496z m0 176.20992c84.82816 0 153.6 68.77184 153.6 153.6s-68.77184 153.6-153.6 153.6-153.6-68.77184-153.6-153.6 68.76672-153.6 153.6-153.6z m289.27488 702.65344S690.59584 993.28 517.15584 993.28c-173.43488 0-293.06368-102.51776-293.06368-102.51776V834.2528c0-164.68992 129.52064-298.1888 289.28-298.1888 159.76448 0 289.27488 133.49888 289.27488 298.1888v58.2656z" p-id="1675"></path>
      </svg>
    )
  }
})


export const VipCircleFilled = defineComponent({
  name: 'icon-vip-circle-filled',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M512.85504 7.68C234.79296 7.68 9.38496 233.088 9.38496 511.14496s225.408 503.47008 503.47008 503.47008c278.05184 0 503.46496-225.41312 503.46496-503.47008S790.90688 7.68 512.85504 7.68z m279.14752 333.54752l-264.65792 407.26528a15.6928 15.6928 0 0 1-11.67872 6.29248H453.51936a12.11392 12.11392 0 0 1-10.3424-6.9632l-165.08928-405.8112c-1.57696-3.81952 0.55808-7.07584 4.60288-7.07584h189.25056c4.16256 0 5.95968 3.03104 3.93728 6.6304l-26.85952 39.66976a17.84832 17.84832 0 0 0-0.78848 13.59872l55.8592 145.31072c1.57696 3.8144 4.608 4.16256 6.85056 0.67584l129.23392-199.59296c2.82112-3.70688 7.0912-6.07232 11.69408-6.29248h136.65792c4.15232 0 5.72928 2.81088 3.47648 6.29248z" p-id="1816"></path>
      </svg>
    )
  }
})


export const LuggageCircleFilled = defineComponent({
  name: 'icon-luggage-circle-filled',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M594.4064 26.33216c58.58816 0 106.83392 46.02368 109.5936 104.54528l0.09728 5.16608v36.57216h161.67424c58.57792 0 106.8288 46.0288 109.58848 104.54528l0.12288 5.1712v536.37632c0 58.58304-46.02368 106.83392-104.54528 109.5936l-5.1712 0.12288h-709.12c-58.58304 0-106.83392-46.0288-109.5936-104.5504l-0.12288-5.1712V282.33216c0-58.58304 46.0288-106.83392 104.54528-109.5936l5.16608-0.12288H317.44v-36.57216C317.44 77.44512 363.49952 29.184 422.03648 26.44992l5.12-0.11776h167.24992zM329.2672 372.29568a36.57216 36.57216 0 0 0-36.57216 36.57216V701.44l0.16896 3.5328a36.57728 36.57728 0 0 0 72.97536-3.5328V408.86784l-0.16896-3.51232a36.57728 36.57728 0 0 0-36.4032-33.05984z m365.47072 0a36.57728 36.57728 0 0 0-36.57728 36.57216V701.44l0.16896 3.5328a36.57728 36.57728 0 0 0 72.97536-3.5328V408.86784l-0.16896-3.51232a36.56192 36.56192 0 0 0-36.39808-33.05984z m-100.33152-272.8192H427.18208a36.57728 36.57728 0 0 0-36.4032 33.05984l-0.16896 3.51232-0.0256 36.57216h240.37376v-36.57216a36.56704 36.56704 0 0 0-33.03424-36.39808l-33.28-0.16896h29.76256z" p-id="1957"></path>
        <path fill="currentColor" d="M279.52128 884.29568a36.57728 36.57728 0 0 1 36.4032 33.05984l0.16896 3.51232v48.76288a36.57216 36.57216 0 0 1-72.97024 3.51232l-0.16896-3.51232v-48.76288a36.56192 36.56192 0 0 1 36.56704-36.57216z m463.23712 0a36.56704 36.56704 0 0 1 36.39808 33.05984l0.16896 3.51232v48.76288a36.57216 36.57216 0 0 1-72.96512 3.51232l-0.16896-3.51232v-48.76288a36.56704 36.56704 0 0 1 36.56704-36.57216z" p-id="1958"></path></svg>)
  }
})


export const ExplainCircleFilled = defineComponent({
  name: 'icon-explain-circle-filled',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2098" width="20">
        <path fill="currentColor" d="M512 12.8C236.29824 12.8 12.8 236.29824 12.8 512s223.49824 499.2 499.2 499.2 499.2-223.49824 499.2-499.2S787.70176 12.8 512 12.8z m75.35104 724.07552c-73.33376 78.43328-166.73792 103.43424-177.77664 44.40576-8.36096-44.48768 35.456-205.78816 44.2368-266.496 2.92352-19.90144-22.07744 0-22.07744 0s-72.07936 50.67264-88.63744 22.15936c-2.67776-4.51584 15.13472-18.47808 22.15936-22.15936h0.16896s150.51264-110.37696 199.3472-88.8832-17.31072 157.5424-22.15936 177.6896-35.95264 174.2592 66.8928 88.8832c0 0 51.1744-34.03264-22.15424 44.40064z m44.09856-451.3536c-2.19136 42.89024-38.7328 75.88864-81.62816 73.7024-42.89024-2.18624-75.88864-38.7328-73.7024-81.62816l0.01536-0.28672c2.29376-42.79296 38.81472-75.64288 81.6128-73.41568 42.89536 2.18624 75.88864 38.7328 73.7024 81.62816z" p-id="2099"></path>
      </svg>
    )
  }
})
export const Delete = defineComponent({
  name: 'icon-delete',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2237" width="20">
        <path fill="currentColor" d="M899.994 258.56H688.435v-48.947c0-59.392-48.333-107.725-107.725-107.725H436.992c-59.392 0-107.725 48.333-107.725 107.725v48.947H131.123c-19.814 0-35.84 16.026-35.84 35.84s16.026 35.84 35.84 35.84h58.675v434.227c0 80.691 65.639 146.279 146.279 146.279h346.265c80.692 0 146.279-65.639 146.279-146.279V330.24h71.321c19.815 0 35.84-16.026 35.84-35.84s-15.974-35.84-35.788-35.84z m-499.047-48.947c0-19.866 16.18-36.045 36.045-36.045h143.77c19.865 0 36.044 16.18 36.044 36.045v48.947H400.947v-48.947z m356.045 554.803c0 41.165-33.485 74.598-74.598 74.598H336.128c-41.165 0-74.598-33.484-74.598-74.598V330.24h495.513v434.176z" p-id="2238"></path>
        <path fill="currentColor" d="M412.928 439.603c-19.814 0-35.84 16.026-35.84 35.84v219.239c0 19.814 16.026 35.84 35.84 35.84s35.84-16.026 35.84-35.84V475.443c0-19.814-16.026-35.84-35.84-35.84z m188.518 0c-19.814 0-35.84 16.026-35.84 35.84v219.239c0 19.814 16.026 35.84 35.84 35.84s35.84-16.026 35.84-35.84V475.443c0-19.814-16.076-35.84-35.84-35.84z" p-id="2239"></path>
      </svg>
    )
  }
})
export const SquareChecked = defineComponent({
  name: 'icon-square-checked',
  setup() {
    return () => (
      <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M196.923 0h630.154A196.923 196.923 0 0 1 1024 196.923v630.154A196.923 196.923 0 0 1 827.077 1024H196.923A196.923 196.923 0 0 1 0 827.077V196.923A196.923 196.923 0 0 1 196.923 0z m0 78.77A118.154 118.154 0 0 0 78.77 196.922v630.154A118.154 118.154 0 0 0 196.923 945.23h630.154A118.154 118.154 0 0 0 945.23 827.077V196.923A118.154 118.154 0 0 0 827.077 78.77H196.923z m584.901 258.205a36.51 36.51 0 0 1 1.26 51.633l-299.48 313.108c-0.118 0.157-0.394 0.236-0.63 0.472l-0.394 0.552c-2.166 2.126-4.726 3.23-7.208 4.726-1.575 0.866-2.796 2.166-4.41 2.836a35.8 35.8 0 0 1-27.491 0.078c-1.26-0.512-2.285-1.614-3.545-2.284-2.757-1.457-5.592-2.836-8.034-5.12-0.197-0.158-0.276-0.433-0.512-0.67-0.197-0.118-0.394-0.196-0.552-0.354L279.985 545.359a36.43 36.43 0 0 1 0.945-51.633 36.391 36.391 0 0 1 51.634 0.945l124.455 129.103 273.093-285.618a36.549 36.549 0 0 1 51.712-1.181z" p-id="1390"></path>
      </svg>
    )
  }
})
export const Square = defineComponent({
  name: 'icon-square',
  setup() {
    return () => (
      <svg  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20">
        <path fill="currentColor" d="M196.923 78.77A118.154 118.154 0 0 0 78.77 196.922v630.154A118.154 118.154 0 0 0 196.923 945.23h630.154A118.154 118.154 0 0 0 945.23 827.077V196.923A118.154 118.154 0 0 0 827.077 78.77H196.923z m0-78.77h630.154A196.923 196.923 0 0 1 1024 196.923v630.154A196.923 196.923 0 0 1 827.077 1024H196.923A196.923 196.923 0 0 1 0 827.077V196.923A196.923 196.923 0 0 1 196.923 0z"></path>
      </svg>
    )
  }
})

















